export const DelayToastTime = 3.5
export const CSSDisappearTime = 3000